export enum ClientActionEnum {
  'DISTRACT' = 'distract',
  'GIVE_UP' = 'give-up',
  'PROPOSAL' = 'proposal',
  'DOWNLOAD' = 'download',
  'SEND_CONTRACT_EMAIL' = 'send-contract-email',
  'SCHEDULE_CONTACT' = 'schedule_contact',
  'INFORM_CONTACT' = 'inform_contact',
}
